import request from '@/utils/httpRequest'

export default class pickingService {
    queryById(id) {
        return request({
            url: '/pick/view',
            method: 'post',
            params: {
                id: id
            },
            class:'mater'
        })
    }
}
